module.exports = __webpack_public_path__ + "static/burger-d6fa1d7d341370a0c25426e6ed8c2512.png";